

import { DatePipe } from '@angular/common';
import { noUndefined } from '@angular/compiler/src/util';
import { Component, OnInit, TemplateRef, HostListener, ElementRef } from '@angular/core';
import { async } from '@angular/core/testing';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { RedirecFormService } from 'src/app/services/redirec-form.service';
import { SocketioService } from 'src/app/services/socket/socketio.service';
import { UserService } from 'src/app/services/user/user.service';
import { environment } from 'src/environments/environment';
import Swal from'sweetalert2';
import * as alertifyjs from 'alertifyjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-contact-financial-payments',
  templateUrl: './contact-financial-payments.component.html',
  styleUrls: ['./contact-financial-payments.component.css'],
  providers: [DatePipe]

})
export class ContactFinancialPaymentsComponent implements OnInit {

  queryParams: any;
  person: any;
  section_transactions: any = [];
  isNeteable: any = [];
  payment_base: any = [];

  transaction: any = {};
  section_transaction: any;
  loading_person = false;
  loading = false;

  buro_response: any;
  buro: any;
  buro_score: any;
  activatePsico: any;
  showActivatePsico: any;

  loading_buro = false;
  psicometrico: any;
  psicometrico_response: any;
  psicometrico_array: any = [];
  status_approved: any;
   type_approved: any;
   clientQuota:any;
   invoiceCredits: any = [];
   resp_invoiceCredits: any = [];
   installments: any = [];
   installmentNexPayment :any;
view = 1;
invoiceSelected:any;
installMentSelected:any;
payment:any;
env = environment;

remanenteInvoices:any ={};
params_payment:any;

// 📋 Propiedades para manejo de pólizas
selectedPolicy: any = null;
selectedPolicyInvoice: string = '';
loadingPolicy: boolean = false;
policyError: string = '';

// Multiple filter properties
filterOptions = {
  pending: false,
  completed: false,
  trash: false
};
filteredInvoiceCredits: any[] = [];

// 💎 FILTRO MÚLTIPLE DE PRODUCTOS - Propiedades
selectedProducts: string[] = ['CREDIT']; // Productos seleccionados (estado final) - CREDIT por defecto
showDropdown: boolean = false; // Visibilidad del dropdown
filterStates = {
  isLoadingProducts: false,    // Cargando lista de productos
  isApplyingFilter: false,     // Aplicando filtro seleccionado
  isLoadingResults: false,     // Cargando resultados de compras
  hasError: false,             // Estado de error
  errorMessage: '',            // Mensaje de error específico
  isInitialized: false         // Si el filtro ya se inicializó
};
tempSelectedProducts: string[] = ['CREDIT']; // Productos temporales (before applying) - CREDIT por defecto
dropdownAnimation = {
  isOpening: false,
  isClosing: false
};
productArray: any[] = []; // Lista de productos disponibles

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _user: UserService,
    private sanitizer: DomSanitizer,
    private redirecFormService: RedirecFormService,
    private datePipe: DatePipe,
    public socketService: SocketioService,
    public _auth : AuthService,
    private offcanvasService: NgbOffcanvas,
    private elementRef: ElementRef
  ) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.queryParams = params;
      if (this.queryParams?.code) {
        this.getPerson().then(() => this.handleDeepLinkQueryParams());
      }
    });
  }

  // Deep-link entry point: la consola de Insurance Console abre esta ruta
  // con ?invoice=<code> para llevar al ejecutivo directo al detalle de
  // pagos de una póliza con error de notif (View 2 = cuotas; el "Ver
  // pagos" de cada cuota lleva a View 3 que es el detalle del pago).
  // Si el invoice no aparece en la lista filtrada actual (default CREDIT),
  // disparamos getPersonInstallmentsInvoiceCredits con un objeto mock que
  // solo lleva el code — basta para la llamada al backend.
  private async handleDeepLinkQueryParams(): Promise<void> {
    try {
      const qp = this.activatedRoute.snapshot.queryParams;
      const invoiceCode = qp?.['invoice'];
      if (!invoiceCode) return;
      const fromList = Array.isArray(this.resp_invoiceCredits)
        ? this.resp_invoiceCredits.find((i: any) => i?.code === invoiceCode)
        : null;
      const invoiceToOpen = fromList || { code: invoiceCode };
      await this.getPersonInstallmentsInvoiceCredits(invoiceToOpen);
    } catch (err) {
      console.error('Deep-link handler failed:', err);
    }
  }

  // Método para refrescar los datos
  refreshData = async () => {
    console.log('Refrescando datos...');
    await this.getPerson();
  }

  downloadPdf(url:string){
    fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error('Red error');
            }
            return response.blob();
        })
        .then(blob => {
            const link = document.createElement('a');
            const objectUrl = URL.createObjectURL(blob);
            link.href = objectUrl;
            link.download = 'pagare.pdf';
            link.click();
            link.remove();
        })
        .catch(error => {
            console.error('Error al descargar el archivo:', error);
        });

  }


  getPerson = async () => {
    this.loading_person = true;
    try {

      const resp = await this._user.getPersonbyCode({ code: this.queryParams.code });

      if (!resp || !resp.resp) {
        console.error('No se encontró la persona');
        this.loading_person = false;
        return;
      }

      // 💎 Inicializar filtro de productos
      await this.consultAllProductsInvoices();

      // 💎 Actualizar el término de búsqueda con el filtro por defecto (CREDIT)
      this.updateSearchTermFromSelection();

      const resp_invoiceCredits = await this.listClientInvoiceCreditsWithFilter();

      this.person = resp.resp;
      this.resp_invoiceCredits = resp_invoiceCredits?.res || [];

      // Initialize filter
      this.applyFilter();

      console.log('Datos cargados:', {
        person: this.person,
        invoiceCredits: this.resp_invoiceCredits,
        pending: this.getPendingCount(),
        completed: this.getCompletedCount(),
        trash: this.getTrashCount(),
        total: this.getTotalCount()
      });

      let invoicesPromes:any = [];
      let isNeteable:any = {};

      // Cargar información de remanentes
      if (this.resp_invoiceCredits && this.resp_invoiceCredits.length > 0) {
        this.getRemanentInvoice(this.resp_invoiceCredits);
      }

      this.isNeteable = isNeteable;

    } catch (error) {
      console.error('Error al cargar datos de la persona:', error);
      // Mostrar mensaje de error al usuario
      alertifyjs.error('Error al cargar los datos del cliente');
    }

    this.loading_person = false;
  }


  register_netable_payment = async (code:any) => {

    try {


    let action = 'continuar'


    Swal.fire({
      title: "¿Deseas saldar este crédito?",
      text: "¡No podrás revertir esto!",
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      input: "textarea",
      inputAttributes: {
        autocapitalize: "off"
      },
      showCancelButton: true,
      confirmButtonText: `Si, ${action}!`,
      showLoaderOnConfirm: true,
      preConfirm: async (login) => {
        try {

          if (login?.trim() == '') {
            return Swal.showValidationMessage(`Debe añadir una razón del  neteo`);
          }

        } catch (error) {
          Swal.showValidationMessage(`
            Request failed: ${error}
          `);
        }
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then(async (result) => {
      if (result.isConfirmed) {

        const query = {
          "invoice_code":code,
          "description": result?.value

        };

          const neteado = await this._user.register_netable_payment(query);
          this.getPerson();

          alertifyjs.success(`Operción exitosa`);

        debugger
      }
    });




    } catch (error) {
      console.error(error);

    }



    this.loading_person = false;


  }


  listClientInvoiceCredits = async () => {
    try {
      const data = {
        code_person: this.queryParams?.code
      }

      console.log('Cargando compras financiadas para:', data);

      const response = await this._user.listClientInvoiceCredits(data);

      console.log('Respuesta del servidor:', response);

      if (!response || !response.res) {
        console.warn('No se encontraron compras financiadas');
        return { res: [] };
      }

      return response;

    } catch (error) {
      console.error('Error al cargar compras financiadas:', error);
      // Retornar array vacío en caso de error
      return { res: [] };
    }
  }

  // 💎 FILTRO MÚLTIPLE DE PRODUCTOS - Métodos

  // Cargar productos disponibles
  async consultAllProductsInvoices(){
    try {
      this.filterStates.isLoadingProducts = true;
      this.filterStates.hasError = false;
      console.log('🔄 DEBUG: Iniciando carga de productos...');

      let consultProducts = await this._user.getTypesProductsInvoices();
      await new Promise(resolve => setTimeout(resolve, 300)); // Simulate delay

      this.productArray = consultProducts.resp;
      this.filteredProductArray = [...this.productArray]; // Inicializar array filtrado
      this.tempSelectedProducts = [...this.selectedProducts]; // Initialize temp
      this.filterStates.isInitialized = true;

      console.log('✅ DEBUG: Productos cargados:', this.productArray.length);
    } catch (error) {
      console.error('❌ ERROR: Error al cargar productos:', error);
      this.filterStates.hasError = true;
      this.filterStates.errorMessage = 'Error al cargar tipos de productos';
    } finally {
      this.filterStates.isLoadingProducts = false;
    }
  }

  // Cargar compras financiadas con filtro de productos
  listClientInvoiceCreditsWithFilter = async (codeArray?: any) => {
    try {
      let data: any = {
        code_person: this.queryParams?.code,
        arr_typeProduct: codeArray || this.selectedProducts // Send array of selected products
      }

      console.log('🔄 DEBUG: Cargando compras con filtro:', data);

      return this._user.listClientInvoiceCredits(data);
    } catch (error) {
      console.error('❌ ERROR: Error al cargar compras con filtro:', error);
    }
  }

  // Control del dropdown
  async toggleDropdown() {
    if (!this.filterStates.isInitialized) {
      await this.consultAllProductsInvoices();
    }

    if (this.showDropdown) {
      await this.closeDropdown();
    } else {
      await this.openDropdown();
    }
  }

  async openDropdown() {
    // Inicializar productos si no están cargados
    if (!this.filterStates.isInitialized) {
      await this.consultAllProductsInvoices();
    }
    
    // Sincronizar tempSelectedProducts con selectedProducts al abrir
    this.tempSelectedProducts = [...this.selectedProducts];
    console.log('🔄 Abriendo dropdown - tempSelectedProducts:', this.tempSelectedProducts);
    console.log('🔄 Abriendo dropdown - selectedProducts:', this.selectedProducts);
    
    this.dropdownAnimation.isOpening = true;
    this.showDropdown = true;
    // NO limpiar búsqueda - mantener el término actual
    // Si no hay búsqueda, mostrar todos
    if (!this.productSearchTerm || this.productSearchTerm.trim() === '') {
      this.filteredProductArray = [...this.productArray];
    }
    await new Promise(resolve => setTimeout(resolve, 100));
    this.dropdownAnimation.isOpening = false;
  }

  async closeDropdown() {
    this.dropdownAnimation.isClosing = true;
    await new Promise(resolve => setTimeout(resolve, 150));
    this.showDropdown = false;
    this.dropdownAnimation.isClosing = false;
    // Reset temp to current selection when canceling
    this.tempSelectedProducts = [...this.selectedProducts];
  }

  // Detectar clics fuera del componente para cerrar el dropdown
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.showDropdown) {
      const productSearchContainer = this.elementRef.nativeElement.querySelector('.product-search-input');
      if (productSearchContainer) {
        const clickedInside = productSearchContainer.contains(event.target as Node);
        const clickedOnDropdown = (event.target as HTMLElement).closest('.filter-dropdown');
        
        // Solo cerrar si el clic fue FUERA del contenedor Y fuera del dropdown
        if (!clickedInside && !clickedOnDropdown) {
          this.closeDropdown();
        }
      }
    }
  }

  // Manejo de selección de productos (MÚLTIPLE - mantener checkboxes funcionales)
  onProductSelectionChange(productCode: string, isChecked: boolean) {
    if (isChecked) {
      // Agregar producto si no está ya seleccionado
      if (!this.tempSelectedProducts.includes(productCode)) {
        this.tempSelectedProducts.push(productCode);
      }
    } else {
      // Remover producto de la selección
      this.tempSelectedProducts = this.tempSelectedProducts.filter(code => code !== productCode);
    }

    // ✅ CAMBIO: Permitir deseleccionar todos los productos, incluso CREDIT
    // Ya no forzamos CREDIT si no hay productos seleccionados
    // El backend manejará el caso de array vacío con su lógica por defecto

    // Actualizar el término de búsqueda inmediatamente para reflejar la selección
    this.updateSearchTermFromTempSelection();

    console.log('🔄 DEBUG: Productos temporales seleccionados:', this.tempSelectedProducts);
  }

  // Actualizar el término de búsqueda basado en la selección temporal
  updateSearchTermFromTempSelection() {
    if (this.tempSelectedProducts.length === 0) {
      this.productSearchTerm = 'Ningún producto seleccionado';
    } else if (this.tempSelectedProducts.length === 1) {
      this.productSearchTerm = this.tempSelectedProducts[0];
    } else if (this.tempSelectedProducts.length === 2) {
      this.productSearchTerm = `${this.tempSelectedProducts[0]} y ${this.tempSelectedProducts[1]}`;
    } else {
      this.productSearchTerm = `${this.tempSelectedProducts.length} productos seleccionados`;
    }
  }

  // Aplicar filtros seleccionados
  async applyFilters(updateSearchTerm: boolean = true) {
    try {
      this.filterStates.isApplyingFilter = true;
      this.filterStates.isLoadingResults = true;
      this.filterStates.hasError = false;

      // Confirmar selección
      this.selectedProducts = [...this.tempSelectedProducts];
      console.log('✅ DEBUG: Aplicando filtros con productos:', this.selectedProducts);

      // Actualizar la barra de búsqueda con el texto de los productos seleccionados (solo si se solicita)
      if (updateSearchTerm) {
        this.updateSearchTermFromSelection();
      }

      await this.closeDropdown(); // Smooth closing animation

      const resp = await this.listClientInvoiceCreditsWithFilter(this.selectedProducts);
      await new Promise(resolve => setTimeout(resolve, 400)); // UX delay

      this.resp_invoiceCredits = resp?.res || [];
      this.applyFilter(); // Apply existing status filters

      console.log('📊 DEBUG: Resultados obtenidos:', this.resp_invoiceCredits?.length || 0, 'compras');
    } catch (error) {
      console.error('❌ ERROR al aplicar filtros:', error);
      this.filterStates.hasError = true;
      this.filterStates.errorMessage = 'Error al aplicar filtros';
    } finally {
      this.filterStates.isApplyingFilter = false;
      this.filterStates.isLoadingResults = false;
    }
  }

  // Actualizar el término de búsqueda con los productos seleccionados
  updateSearchTermFromSelection() {
    if (this.selectedProducts.length === 0) {
      this.productSearchTerm = 'Ningún producto seleccionado';
    } else if (this.selectedProducts.length === 1) {
      // Un solo producto: mostrar su código
      this.productSearchTerm = this.selectedProducts[0];
    } else if (this.selectedProducts.length === 2) {
      // Dos productos: mostrar ambos códigos separados por "y"
      this.productSearchTerm = `${this.selectedProducts[0]} y ${this.selectedProducts[1]}`;
    } else {
      // Más de 2 productos: mostrar resumen
      this.productSearchTerm = `${this.selectedProducts.length} productos seleccionados`;
    }
    
    console.log('🔍 Término de búsqueda actualizado:', this.productSearchTerm);
  }

  // Verificar si un producto está seleccionado
  isProductSelected(productCode: string): boolean {
    return this.tempSelectedProducts.includes(productCode);
  }
  // Obtener texto descriptivo de productos seleccionados
  getSelectedProductsText(): string {
    if (this.selectedProducts.length === 1) {
      return this.selectedProducts[0];
    } else if (this.selectedProducts.length === 2) {
      return this.selectedProducts.join(' y ');
    } else if (this.selectedProducts.length > 2) {
      return `${this.selectedProducts.length} productos seleccionados`;
    }
    return 'Seleccionar productos';
  }

  // Limpiar todos los filtros de productos y volver a CREDIT por defecto
  async clearAllProductFilters() {
    this.tempSelectedProducts = ['CREDIT'];
    this.selectedProducts = ['CREDIT'];
    await this.applyFilters();
  }

  // Reintentar operación en caso de error
  async retryOperation() {
    this.filterStates.hasError = false;
    this.filterStates.errorMessage = '';

    if (!this.filterStates.isInitialized) {
      await this.consultAllProductsInvoices();
    } else {
      await this.applyFilters();
    }
  }

  // Track function para *ngFor optimization
  trackByProductCode(index: number, item: any): string {
    return item?.params?.code || index;
  }

  // 💎 BÚSQUEDA DE PRODUCTOS - Propiedades y Métodos
  productSearchTerm: string = 'CREDIT'; // Inicializar con CREDIT por defecto
  filteredProductArray: any[] = [];

  // Filtrar productos por búsqueda
  filterProductsSearch() {
    if (!this.productArray) {
      this.filteredProductArray = [];
      return;
    }

    if (!this.productSearchTerm || this.productSearchTerm.trim() === '') {
      // Si no hay término de búsqueda, mostrar todos los productos
      this.filteredProductArray = [...this.productArray];
      return;
    }

    const term = this.productSearchTerm.toLowerCase().trim();
    this.filteredProductArray = this.productArray.filter((product: any) => {
      return (
        product?.params?.name?.toLowerCase().includes(term) ||
        product?.params?.code?.toLowerCase().includes(term) ||
        (product?.params?.dinamic_code && 
         product.params.dinamic_code.some((code: string) => code.toLowerCase().includes(term)))
      );
    });

    console.log('🔍 Productos filtrados:', this.filteredProductArray.length);
  }

  // Limpiar búsqueda de productos y volver a CREDIT por defecto
  async clearProductSearch() {
    // Limpiar el término de búsqueda visual y volver a CREDIT
    this.productSearchTerm = 'CREDIT';
    this.filteredProductArray = [...this.productArray];
    
    // Volver a CREDIT por defecto
    this.tempSelectedProducts = ['CREDIT'];
    this.selectedProducts = ['CREDIT'];
    
    // Aplicar filtros para reflejar el cambio
    await this.applyFilters();
  }


  getPersonInstallmentsInvoiceCredits = async (invoice:any) => {
    this.loading = true;

    this.invoiceSelected = invoice;
    try {
         const data =  {
          code_invoice:invoice?.code

         }

       const  installments  = await this._user.getPersonInstallmentsInvoiceCredits(data);

       this.installments = installments?.res;
       // Guardar productos del invoice si existen
       if (installments?.order_items) {
         this.invoiceSelected.order_items = installments.order_items;
       }
       let rem:any = this.remanenteInvoices[invoice.code];

       this.installments.map((value:any, index:any) => {

        if(value?.installMent?.payment_status?.code != 'PaymentComplete' && !this.installmentNexPayment){

          this.installmentNexPayment = value?.installMent?.code;

        }

        value["totalpaymentReference"] = 0;

        value?.paymentReference?.forEach((value2:any) =>{
          value["totalpaymentReference"] =  this.toFixedApp(value["totalpaymentReference"]  +  value2?.payment?.amount);
        });


        value?.fees?.map((value2: any, index: any) => {
          // Filtrar fee_payments y referencias con amount = 0 (data fantasma:
          // ver problematic_payments_20260205_report.json y docs/AUDITORIA_COMPLETA_CARTERA_16_TIPOS.md
          // — son distribuciones erróneas que no representan dinero real).
          value2['paymentsClean'] = Array.isArray(value2?.payments)
            ? value2.payments.filter((p: any) => Number(p?.amount) > 0)
            : [];
          value2['paymentsFeeReferencesClean'] = Array.isArray(value2?.paymentsFeeReferences)
            ? value2.paymentsFeeReferences.filter((p: any) => Number(p?.payment?.amount) > 0)
            : [];

          value2['totalFeePaymentReference'] = value2['paymentsFeeReferencesClean']
            .reduce((acc: number, curr: any) => acc + Number(curr?.payment?.amount || 0), 0);

          const code = value2?.payment_status?.code;
          const dueBalance = Number(value2?.due_balance ?? 0);
          if (code === 'PaymentInactivo' || value2?.manual_deleted) {
            value2['_visualStatus'] = 'inactive';
          } else if (code === 'PaymentComplete') {
            value2['_visualStatus'] = 'complete';
          } else if (code === 'PaymentPending' && dueBalance <= 0 && !value2?.exonerated) {
            value2['_visualStatus'] = 'awaiting-close';
          } else {
            value2['_visualStatus'] = 'pending';
          }
        });

        value.installMent['total_dueBalance'] =  this.toFixedApp(value.installMent?.dueBalance - value.totalpaymentReference);


        if(rem?.next_installment?.code == value?.installMent?.code){

          value.installMent['payment_status_remante_next'] = true;
          value.installMent['total_remaining_next'] =  rem?.remaining_amount;
          value.installMent['total_dueBalance_next'] =  rem?.total_amount_next_installment;

          value.installMent['date_remaining_next'] =  rem?.date;

        }

        if(rem?.installment?.code == value?.installMent?.code){

          value.installMent['payment_status_remante_base'] = true;
          value.installMent['total_remaining_base'] =  rem?.remaining_amount;
          value.installMent['date_remaining_base'] =  rem?.date;
          value.installMent['date_remaining_dueBalance'] =  this.toFixedApp(rem?.installment?.amount - rem?.installment?.dueBalance);


        }

        // calculo por penalidades



        return value;
      });



/*
      this.installments.sort((a:any, b:any) => {
        let temp = a?.installMent?.order;
        let temp2 = b?.installMent?.order;

        return  temp - temp2;
      });*/


       this.view = 2;

      } catch (error) {
        console.error(error);

      }

      this.loading = false;

  }


  getPersonInstallmentpayment = async (installMentSelected:any) => {

    this.loading = true;

    this.installMentSelected = installMentSelected;
    try {
         const data =  {
          code_installMent:installMentSelected?.code

         }

       const  payment  = await this._user.getPersonInstallmentpayment(data);

       this.payment_base = payment?.res;
       this.view = 3;

      } catch (error) {
        console.error(error);


      }

      this.loading = false;

  }


  getIdentity(item: any) {

    if (!(item?.identitys?.length > 0))
      return "";

    return `${item?.identitys[0]?.type_identity?.name} ${item?.identitys[0]?.code_identity?.name}-${item?.identitys[0]?.identity}`;

  }


  getNumberIdentity(item: any) {

    if (!(item?.identitys?.length > 0))
      return "";

    return `${item?.identitys[0]?.identity}`;

  }


  getContact(item: any) {

    if (!(item?.constacts?.length > 0))
      return "";

    return `${item?.constacts[0]?.contact}`;


  }

  getEmailContact(item: any) {
    if (!(item?.constacts?.length > 0) || !item?.constacts[1]) return '';

    return `${item?.constacts[1]?.contact}`;
  }


  sanitize(url: string) {
    //return url;
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }



  public redirect = () => {

    let Doc_ID;
    let Type_ID;
    let TLF;


    if (this.person?.identitys?.length > 0) {

      const data = this.person?.identitys[0];
      Type_ID = data.type_identity?.additionalType;
      Doc_ID = data.identity;

    }


    const data = {

      CED: environment.CED,
      IP: environment.IP_LOCAL,
      Type_ID,
      Doc_ID,
      PN: this.person?.person?.name,
      PA: this.person?.person?.lastName,
      FN: this.datePipe.transform(this.person?.person?.birth_date, 'yyyy-MM-dd'),
      GN: this.person?.person?.gender,
      TLF: "",
      EMAIL: ""

    }

    this.redirecFormService.postRedirect(environment.externalPsicometrico, data);

  }

  closeInstallment(){

    if(this.view == 2 ){
      this.installments = [];
      this.view = 1;
      this.invoiceSelected=null;
      this.installmentNexPayment = null;

    }else  if(this.view == 3 ){
      this.view = 2;
      this.installMentSelected = null;
      this.payment_base = null;
      this.installmentNexPayment = null;

    }

         }

restClient = async () =>  {

  if (this.person?.identitys?.length > 0) {
    this.loading = true;

    const data:any = this.person?.identitys[0];

    let params = {

      "client": {
        "type_identity": data.type_identity?.code,
        "code_identity": data.code_identity?.code,
        "identity": data.identity
      }

    };

  try {

    let resp = await this._user.clientQuotaReset(params);



    this.installments = [];
    this.resp_invoiceCredits = [];
    this.invoiceSelected=null;
    this.invoiceSelected=null;
    this.installMentSelected = null;
    this.payment_base = null;
    this.view = 1;


    this.getPerson();


   }  catch (error:any) {

        const params = error?.error?.error;
        if(params?.code){
        }

   }
   this.loading = false;

}
}



redirectTo() {
  this.router.navigate([`/console/payments/person/${this.person?.person?.code}`], {});
}

setIdentity(){
  localStorage.setItem('identity',this.getNumberIdentity(this.person));

}


getRemanentInvoice = async (invoices:any) => {
  try {
    if (!invoices || !Array.isArray(invoices) || invoices.length === 0) {
      console.log('No hay facturas para procesar remanentes');
      return;
    }

    let promes_reman:any = [];

    invoices.forEach((value:any) => {
      if (value?.code) {
        promes_reman = [...promes_reman,
          this._user.getRemanentInvoice({
            "invoiceCode": value.code,
            "status": true
          })
        ];
      }
    });

    if (promes_reman.length === 0) {
      console.log('No hay promesas de remanentes para procesar');
      return;
    }

    let remanentInvoices = await Promise.all(promes_reman);
    let remanenteInvoices:any = {};

    remanentInvoices?.forEach((remanentArray:any) => {
      if (Array.isArray(remanentArray)) {
        remanentArray.forEach((value2:any) => {
          if (value2?.invoice?.code) {
            remanenteInvoices[value2.invoice.code] = value2;
          }
        });
      }
    });

    this.remanenteInvoices = remanenteInvoices;
    console.log('Remanentes cargados:', this.remanenteInvoices);

  } catch (error) {
    console.error('Error al cargar remanentes:', error);
    this.remanenteInvoices = {};
  }
}



toFixedApp = (x:any) => {

  let a:any = `e+${2}`;
  let b:any = `e-${2}`;

  return +(Math.round(x + a) + b);

  //return Number(Number.parseFloat(String((x + Number.EPSILON))).toFixed(TOFIXED));

}

restab(a:any,b:any){

  return  this.toFixedApp( a - b);

}


anularCompra = async (param:any) => {

  let action = 'Anular'

  Swal.fire({
    title: `¿Deseas Anular la compra ${param?.identifier} ?`,
    html: '¡No podrás revertir esto!<br><small class="text-muted">Redacta el motivo de la anulación (quedará registrado para auditoría).</small>',
    icon: 'warning',
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    input: 'textarea',
    inputPlaceholder: 'Describe detalladamente el motivo por el cual se anula esta compra...',
    inputAttributes: {
      'aria-label': 'Motivo de la anulación',
      maxlength: '500'
    },
    showCancelButton: true,
    confirmButtonText: `Si, ${action}!`,
    showLoaderOnConfirm: true,
    preConfirm: async (reason: string) => {
      const value = (reason || '').trim();
      if (!value) {
        return Swal.showValidationMessage('El motivo de la anulación es obligatorio');
      }
      if (value.length < 5) {
        return Swal.showValidationMessage('El motivo debe tener al menos 5 caracteres');
      }
      return value;
    },
    allowOutsideClick: () => !Swal.isLoading()
  }).then((result) => {

    if (result.isConfirmed) {

     this.anularCompraService(param?.code, result.value);


    }
  });
}



anularCompraService = async (code:any, reason:string = '') =>  {


  let params = {

    "credit_code": code,
    "reason": reason

  };

try {



  let resp = await this._user.anularCompra(params);
 this.getPerson();

 }  catch (error:any) {

      const params = error?.error?.error;
      if(params?.code){
      }

 }


}


openBottom= async (content: TemplateRef<any>,params_invoice:any) => {
  try {
    console.log(params_invoice);

    this.params_payment = params_invoice;

    this.offcanvasService.open(content, {
      position: 'bottom',
      keyboard: false,

    });


  } catch (error) {
    console.log(error);
  }
};

response = (event: any) => {

}

// Statistics methods for the dashboard cards
getPendingCount(): number {
  try {
    if (!this.resp_invoiceCredits || !Array.isArray(this.resp_invoiceCredits) || this.resp_invoiceCredits.length === 0) {
      return 0;
    }
    const count = this.resp_invoiceCredits.filter((item: any) =>
      item?.payment_status?.code === 'PaymentPending'
    ).length;
    console.log('Pending count:', count);
    return count;
  } catch (error) {
    console.error('Error calculating pending count:', error);
    return 0;
  }
}

getCompletedCount(): number {
  try {
    if (!this.resp_invoiceCredits || !Array.isArray(this.resp_invoiceCredits) || this.resp_invoiceCredits.length === 0) {
      return 0;
    }
    const count = this.resp_invoiceCredits.filter((item: any) =>
      item?.payment_status?.code === 'PaymentComplete'
    ).length;
    console.log('Completed count:', count);
    return count;
  } catch (error) {
    console.error('Error calculating completed count:', error);
    return 0;
  }
}

getTrashCount(): number {
  try {
    if (!this.resp_invoiceCredits || !Array.isArray(this.resp_invoiceCredits) || this.resp_invoiceCredits.length === 0) {
      return 0;
    }
    const count = this.resp_invoiceCredits.filter((item: any) =>
      item?.payment_status?.code === 'PaymentTrash'
    ).length;
    console.log('Trash count:', count);
    return count;
  } catch (error) {
    console.error('Error calculating trash count:', error);
    return 0;
  }
}

getTotalCount(): number {
  try {
    if (!this.resp_invoiceCredits || !Array.isArray(this.resp_invoiceCredits)) {
      return 0;
    }

    // Solo contar Pendientes y Completados, excluyendo En borrador (PaymentTrash)
    const count = this.resp_invoiceCredits.filter((item: any) =>
      item?.payment_status?.code === 'PaymentPending' ||
      item?.payment_status?.code === 'PaymentComplete'
    ).length;

    console.log('Total count (excluding draft):', count);
    return count;
  } catch (error) {
    console.error('Error calculating total count:', error);
    return 0;
  }
}

// Function to map payment status names to shorter versions
getStatusDisplayName(statusName: string): string {
  if (!statusName) return '';

  const statusMap: { [key: string]: string } = {
    'Pago Pendiente': 'Pendiente',
    'Pago Completado': 'Completado',
    'Pago Anulado': 'Anulado',
    'Pago Trash': 'Anulado'
  };

  return statusMap[statusName] || statusName;
}

// Filter methods
applyFilter(): void {
  // Verificar que resp_invoiceCredits esté disponible
  if (!this.resp_invoiceCredits || !Array.isArray(this.resp_invoiceCredits)) {
    this.filteredInvoiceCredits = [];
    return;
  }

  // Si no hay filtros activos, mostrar todos
  if (!this.hasActiveFilters()) {
    this.filteredInvoiceCredits = [...this.resp_invoiceCredits];
  } else {
    // Filtrar basado en las opciones seleccionadas
    this.filteredInvoiceCredits = this.resp_invoiceCredits.filter((item: any) => {
      const status = item?.payment_status?.code;

      return (
        (this.filterOptions.pending && status === 'PaymentPending') ||
        (this.filterOptions.completed && status === 'PaymentComplete') ||
        (this.filterOptions.trash && status === 'PaymentTrash')
      );
    });
  }

  console.log('Multiple filter applied:', {
    filterOptions: this.filterOptions,
    hasActiveFilters: this.hasActiveFilters(),
    totalInvoices: this.resp_invoiceCredits?.length || 0,
    filteredResults: this.filteredInvoiceCredits.length
  });
}

hasActiveFilters(): boolean {
  return this.filterOptions.pending || this.filterOptions.completed || this.filterOptions.trash;
}

selectAllFilters(): void {
  this.filterOptions.pending = true;
  this.filterOptions.completed = true;
  this.filterOptions.trash = true;
  this.applyFilter();
}

clearAllFilters(): void {
  this.filterOptions.pending = false;
  this.filterOptions.completed = false;
  this.filterOptions.trash = false;
  this.applyFilter();
}

// New functions to handle individual filter toggles for the clickable boxes
togglePendingFilter(): void {
  // Si ya está activo, limpiar todos los filtros; si no, activar solo pendientes
  if (this.filterOptions.pending && !this.filterOptions.completed && !this.filterOptions.trash) {
    this.clearAllFilters();
  } else {
    this.filterOptions.pending = true;
    this.filterOptions.completed = false;
    this.filterOptions.trash = false;
  this.applyFilter();
  }
}

toggleCompletedFilter(): void {
  // Si ya está activo, limpiar todos los filtros; si no, activar solo completados
  if (this.filterOptions.completed && !this.filterOptions.pending && !this.filterOptions.trash) {
    this.clearAllFilters();
  } else {
    this.filterOptions.pending = false;
    this.filterOptions.completed = true;
    this.filterOptions.trash = false;
  this.applyFilter();
  }
}

toggleTrashFilter(): void {
  // Si ya está activo, limpiar todos los filtros; si no, activar solo borrador
  if (this.filterOptions.trash && !this.filterOptions.pending && !this.filterOptions.completed) {
    this.clearAllFilters();
  } else {
    this.filterOptions.pending = false;
    this.filterOptions.completed = false;
    this.filterOptions.trash = true;
  this.applyFilter();
  }
}

toggleTotalFilter(): void {
  // Si ambos filtros (pendientes y completados) están activos, limpiar todos los filtros
  // Si no, activar solo pendientes y completados (excluyendo borrador)
  if (this.filterOptions.pending && this.filterOptions.completed && !this.filterOptions.trash) {
    this.clearAllFilters();
  } else {
    this.filterOptions.pending = true;
    this.filterOptions.completed = true;
    this.filterOptions.trash = false; // Asegurar que borrador esté desactivado
    this.applyFilter();
  }
}

// Check if specific filter is active
isPendingFilterActive(): boolean {
  return this.filterOptions.pending && !this.filterOptions.completed && !this.filterOptions.trash;
}

isCompletedFilterActive(): boolean {
  return this.filterOptions.completed && !this.filterOptions.pending && !this.filterOptions.trash;
}

isTrashFilterActive(): boolean {
  return this.filterOptions.trash && !this.filterOptions.pending && !this.filterOptions.completed;
}

isTotalFilterActive(): boolean {
  return this.filterOptions.pending && this.filterOptions.completed && !this.filterOptions.trash;
}

getDisplayedInvoices(): any[] {
  if (!this.hasActiveFilters()) {
    return this.resp_invoiceCredits || [];
  }
  return this.filteredInvoiceCredits || [];
}

// Navigate to customer profile
navigateToProfile(): void {
  if (this.person?.person?.code) {
    this.router.navigate(['/console/person/profile', this.person.person.code]);
  }
}

// 📋 Verificar si el producto es un seguro
isInsuranceProduct(item: any): boolean {
  const typeProduct = item?.params?.product_type?.type || item?.payment?.typeProduct || 'CREDIT';
  return typeProduct === 'SEGUROS_MERCANTIL' || typeProduct === 'SEGUROS_CARACAS';
}

// 📋 Ver detalles de la póliza
async viewPolicy(item: any) {
  console.log('📋 Cargando póliza para invoice:', item?.code);
  console.log('📋 Item completo:', item);
  
  this.loadingPolicy = true;
  this.policyError = '';
  this.selectedPolicyInvoice = item?.code;
  this.selectedPolicy = null;

  try {
    const response = await this._user.getPolicyByInvoice(item?.code);
    console.log('📋 Respuesta completa del endpoint:', response);

    if (response && response.ok) {
      // Extraer solo los datos solicitados
      this.selectedPolicy = {
        // Código de la póliza
        code: response.code || 'N/A',
        // Tasa de cambio
        exchange_rate: response.exchange_rate || 0,
        // Número de póliza
        policy_number: response.policy_number || 'N/A',
        // Número de recibo
        receipt_number: response.receipt_number || 'N/A',
        // Producto de seguro
        insurance_product: response.insurance_product || 'N/A',
        // Nombre del producto (si viene como objeto)
        product_name: typeof response.insurance_product === 'object' ? response.insurance_product?.name : response.insurance_product,
        product_code: typeof response.insurance_product === 'object' ? response.insurance_product?.code : null
      };
      
      console.log('✅ Póliza procesada correctamente:', this.selectedPolicy);
      alertifyjs.success('Póliza cargada exitosamente');
    } else {
      console.warn('⚠️ La respuesta no tiene ok: true');
      this.policyError = 'No se pudo cargar la información de la póliza';
      alertifyjs.warning('No se encontró información de la póliza');
    }
  } catch (error: any) {
    console.error('❌ Error completo al cargar póliza:', error);
    console.error('❌ Error.error:', error?.error);
    console.error('❌ Error.message:', error?.message);
    
    const errorMessage = error?.error?.message || error?.message || 'Error al cargar la información de la póliza';
    this.policyError = errorMessage;
    alertifyjs.error(`Error: ${errorMessage}`);
  } finally {
    this.loadingPolicy = false;
  }
}

// 📋 Obtener nombre de la aseguradora según el código del producto
getInsuranceCompanyName(insuranceProduct: any): string {
  const productCode = typeof insuranceProduct === 'string' ? insuranceProduct : insuranceProduct?.code;
  
  if (productCode && productCode.includes('MER')) {
    return 'Seguros Mercantil';
  } else if (productCode && productCode.includes('CARACAS')) {
    return 'Seguros Caracas';
  }
  return 'Aseguradora';
}

// 📋 Cerrar vista de póliza
closePolicy() {
  this.selectedPolicy = null;
  this.selectedPolicyInvoice = '';
  this.policyError = '';
}

// Format external payment detected date to 12-hour format with AM/PM
formatExternalPaymentDate(dateString: string): string {
  if (!dateString) return '';
  
  try {
    // Parse the date string - it could be in different formats
    const date = new Date(dateString);
    
    // If invalid date, return original string
    if (isNaN(date.getTime())) return dateString;
    
    // Format to DD/MM/YYYY HH:mm:ss AM/PM
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    
    hours = hours % 12;
    hours = hours ? hours : 12; // 0 should be 12
    const hoursStr = String(hours).padStart(2, '0');
    
    return `${day}/${month}/${year} ${hoursStr}:${minutes}:${seconds} ${ampm}`;
  } catch (error) {
    return dateString;
  }
}

}
